<template>
  <div>
    <div class="d-flex align-center">
      <h3>Categorias mais vendidas</h3>
      <v-spacer></v-spacer>
    </div>

    <v-divider class="ma-2"></v-divider>
    <v-data-table
      :items="categorySales"
      :loading="categoryloading"
      :headers="categoryHeaders"
      class="content-table"
      hide-default-footer
      loading-text="Buscando..."
      no-data-text="Sem registros"
    >
      <template v-slot:[`item.salesValue`]="{ item }">
        {{
          item.salesValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        }}
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "SkusDashResale",
  components: {Pagination},

  props: {
    filter: {
      resaleId: "",
      startDate: "",
      endDate: "",
    },
  },

  data() {
    return {
      categorySales: [],
      page: 1,
      totalPages: 1,
      pageSize: 10,
      currentPage: 1,
      totalItems: 1,
      categoryHeaders: [
        {
          text: "Categoria",
          align: "center",
          value: "category",
        },
        {
          text: "Quantidade",
          align: "center",
          value: "salesQuantity",
          sortable: false,
        },
      ],
      headerProps: {
        sortByText: "Ordenar por",
      },

      categoryloading: false,
      apiService: new ApiService(),
    };
  },

  created() {
    this.getCategorySales();
  },

  methods: {
    getCategorySales() {
      this.categoryloading = true;
      this.apiService
        .post("dashresale/categories", { ...this.filter, page: this.page })
        .then((response) => {
          console.log(response)
          this.categorySales = response.content.data;
          this.totalPages = response.content.pager.totalPages;
          this.currentPage = response.content.pager.currentPage;
          this.totalItems = response.content.pager.totalItems;
          this.categoryloading = false;
        })
        .catch(() => {
          this.categoryloading = false;
        });
    },

    async backPage() {
      this.page -= 1;
      await this.getCategorySales();
    },

    async nextPage() {
      this.page += 1;
      await this.getCategorySales();
    },
  },

  watch: {},
};
</script>

<style></style>
